

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ReferralSettingsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface ReferralSettings {
    id?: number;
    referralType:string;
    physicianId:any;
    employeeId:any;
    referralId:any
    standardPercentage:string;
    standardAmount:any;
    calculationMethod:any;
    tenantId: any;
    branchId: any;

  parameters?: ReferralSettingsParameter[];
  links?: any;
}

export abstract class ReferralSettingsData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<ReferralSettings[]>;
  abstract create(url: string, data: ReferralSettings): Observable<ReferralSettings>;
  abstract update(url: string, data: ReferralSettings): Observable<ReferralSettings>;
  abstract delete(url: string): Observable<any>;

}
